var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendarLarge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.793,
    height: 37.548,
    viewBox: "0 0 33.793 37.548",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-today",
    "data-name": "Icon material-today",
    d: "M34.538,5.255H32.661V1.5H28.906V5.255H13.887V1.5H10.132V5.255H8.255A3.738,3.738,0,0,0,4.519,9.01L4.5,35.293a3.754,3.754,0,0,0,3.755,3.755H34.538a3.766,3.766,0,0,0,3.755-3.755V9.01A3.766,3.766,0,0,0,34.538,5.255Zm0,30.038H8.255V14.642H34.538ZM12.01,18.4H21.4v9.387H12.01Z",
    transform: "translate(-4.5 -1.5)",
    fill: "#12819c"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarLarge);
export default __webpack_public_path__ + "static/media/calendarLarge.eab2be24ce3a7a874f41c14c352f2e55.svg";
export { ForwardRef as ReactComponent };